var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkoutBtnNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M853.57,419.88h-249.45v-246.03c0-50.72-38.85-92.88-89.57-92.88h-1.26c-50.72,0-93.4,42.16-93.4,92.88v246.03h-245.62c-50.72,0-93.29,42.28-93.29,92.99v1.26c0,50.72,42.57,89.98,93.29,89.98h245.62v249.04c0,50.72,42.68,89.87,93.4,89.87h1.26c50.72,0,89.57-39.15,89.57-89.87v-249.04h249.45c50.72,0,89.46-39.26,89.46-89.98v-1.26c0-50.71-38.74-92.99-89.46-92.99h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutBtnNew);
export default __webpack_public_path__ + "static/media/workout-btn-new.75f32a0d7194b0ce498cb46c24812b27.svg";
export { ForwardRef as ReactComponent };